
const LedgerAccountRoutes = [
    {
        path: '',
        name: 'ledger-account-index',
        component: () => import("@/components/admin/ledger-account/list.vue"),
    },
    {
        path: 'list',
        name: 'list-ledger-account',
        component: () => import("@/components/admin/ledger-account/list.vue"),
    },
    {
        path: 'form',
        name: 'form-ledger-account',
        component: () => import("@/components/admin/ledger-account/form.vue"),
    }
];
export default LedgerAccountRoutes